"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

var _ListItemIcon = _interopRequireDefault(require("../ListItemIcon"));

var _ListItemSecondaryAction = _interopRequireDefault(require("../ListItemSecondaryAction"));

var _ListItemText = _interopRequireDefault(require("../ListItemText"));

var _Button = _interopRequireDefault(require("../Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _styles2 = require("./styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ListItem = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(ListItem, _React$PureComponent);

  var _super = _createSuper(ListItem);

  function ListItem() {
    var _this;

    (0, _classCallCheck2.default)(this, ListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAvatar", function (htmlId) {
      var itemAvatar = _this.props.itemAvatar;

      if (itemAvatar) {
        return /*#__PURE__*/_react.default.createElement(_Avatar.default, {
          id: "avatar-".concat(htmlId),
          size: "medium"
        }, itemAvatar);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderItemText", function (htmlId) {
      var itemText = _this.props.itemText;

      if (itemText) {
        return /*#__PURE__*/_react.default.createElement(_ListItemText.default, (0, _extends2.default)({
          id: "listItemText-".concat(htmlId)
        }, itemText));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderItemSecondaryAction", function (htmlId) {
      var _this$props = _this.props,
          itemSecondaryAction = _this$props.itemSecondaryAction,
          classes = _this$props.classes;

      if (itemSecondaryAction) {
        return /*#__PURE__*/_react.default.createElement(_ListItemSecondaryAction.default, {
          className: classes.secondaryAction,
          id: "listItemSecondaryAction-".concat(htmlId)
        }, itemSecondaryAction);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderItemIcon", function (htmlId) {
      var itemIcon = _this.props.itemIcon;

      if (itemIcon) {
        return /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, {
          id: "listItemIcon-".concat(htmlId)
        }, itemIcon);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderButton", /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
      return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
        ref: ref
      }, props, {
        onClick: _this.props.onClick,
        href: _this.props.href,
        openInNewWindow: _this.props.openInNewWindow,
        component: _this.props.component
      })));
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var itemClasses = "";

      if (_this.props.isSideNav) {
        itemClasses = _this.props.classes.sideNavItem;
      }

      if (_this.props.isProductDropdown) {
        itemClasses = (0, _classnames.default)(_this.props.classes.sideNavItem, _this.props.classes.productNavItem);
      }

      var _this$props2 = _this.props,
          id = _this$props2.id,
          children = _this$props2.children,
          button = _this$props2.button,
          divider = _this$props2.divider,
          selected = _this$props2.selected,
          dense = _this$props2.dense,
          style = _this$props2.style;
      var muiProps = {
        id: id,
        children: children,
        button: button,
        divider: divider,
        selected: selected,
        dense: dense,
        style: style,
        "aria-label": _this.props["aria-label"]
      };
      var _this$props3 = _this.props,
          className = _this$props3.className,
          classes = _this$props3.classes;

      if (muiProps.button) {
        muiProps = _objectSpread(_objectSpread({}, muiProps), {}, {
          component: _this.renderButton,
          variant: "text"
        });
      }

      if (_this.props.iconLocation === "right") {
        return /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({}, muiProps, {
          id: muiProps.id,
          className: (0, _classnames.default)("prmbl-listItem", className, itemClasses),
          classes: {
            selected: classes.selected
          },
          "data-id": _this.props.dataId
        }), _this.renderItemText(muiProps.id), _this.renderAvatar(muiProps.id), _this.renderItemIcon(muiProps.id), _this.renderItemSecondaryAction(muiProps.id));
      }

      return /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({}, muiProps, {
        id: muiProps.id,
        "data-id": _this.props.dataId,
        className: (0, _classnames.default)("prmbl-listItem", className, itemClasses),
        classes: {
          selected: classes.selected
        }
      }), _this.renderAvatar(muiProps.id), _this.renderItemIcon(muiProps.id), _this.renderItemText(muiProps.id), _this.renderItemSecondaryAction(muiProps.id));
    });
    return _this;
  }

  return ListItem;
}(_react.default.PureComponent);

exports.ListItem = ListItem;
(0, _defineProperty2.default)(ListItem, "propTypes", {
  /**
   * The html id.
   */
  id: _propTypes.default.string.isRequired,

  /**
   * the id attribute to be placed on the item if the list item is part of a draggable list.
   */
  dataId: _propTypes.default.string,

  /**
   * If true, the list item will be a button.
   */
  button: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   *
   * Utilized By:
   * Preamble => Page
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If true, the list items will be more compact.
   */
  dense: _propTypes.default.bool,

  /**
   * If true, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes.default.bool,

  /**
   * If `button` = `true`, will be passed to the `Button` component
   */
  href: _propTypes.default.string,

  /**
   *  The [ListItemAvatar](#listitemavatar) for the list item.
   */
  itemAvatar: _propTypes.default.node,

  /**
   * The [ListItemIcon](#listitemicon) for the list item.
   */
  itemIcon: _propTypes.default.node,

  /**
   * Location of Icon or Avatar. If left, Icon or Avatar is located
   * left side of Text.
   */
  iconLocation: _propTypes.default.oneOf(["left", "right"]),

  /**
   * The [ListSecondaryAction](#listsecondaryaction) for the list item
   * (eg. [Checkbox](#checkbox), [Toggle](#toggle)).
   */
  itemSecondaryAction: _propTypes.default.node,

  /**
   * The [ListItemText](#listitemtext) of the list item.
   */
  itemText: _propTypes.default.shape({
    /**
     * Alias for the primary property.
     */
    children: _propTypes.default.node,

    /**
     * If true, the children will be indented. This should be
     * used if there is no left avatar or left icon.
     */
    inset: _propTypes.default.bool,

    /**
     * The main content element.
     */
    primary: _propTypes.default.node,

    /**
     * The secondary content element.
     */
    secondary: _propTypes.default.node
  }),

  /**
   * If `button` = `true`, will be passed to the `Button` component
   */
  onClick: _propTypes.default.func,

  /**
   * If `button` = `true`, will be passed to the `Button` component
   */
  openInNewWindow: _propTypes.default.bool,

  /**
   * Is the item rendered as selected
   */
  selected: _propTypes.default.bool,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   *
   * For sidenav styles
   */
  isSideNav: _propTypes.default.bool,

  /**
   * @ignore
   *
   * For product dropdown styles
   */
  isProductDropdown: _propTypes.default.bool,

  /**
   * Additional styles to render
   */
  style: _propTypes.default.object,

  /**
   * Accessibility label
   */
  "aria-label": _propTypes.default.string
});
(0, _defineProperty2.default)(ListItem, "defaultProps", {
  button: false,
  divider: false,
  iconLocation: "left",
  className: "",
  isSideNav: false,
  isProductDropdown: false
});

var _default = (0, _styles.withStyles)(_styles2.styles)(ListItem);

exports.default = _default;